import { useRecoilState } from 'recoil';
import { columnPositionsAtom, centerOrderAtom } from '../atoms/layoutAtoms';

export function useLayoutSwap() {
  const [positions, setPositions] = useRecoilState(columnPositionsAtom);
  const [centerOrder, setCenterOrder] = useRecoilState(centerOrderAtom);

  const swapLeftCenter = () => {
    setPositions(([left, center, right]) => [center, left, right]);
  };

  const swapRightCenter = () => {
    setPositions(([left, center, right]) => [left, right, center]);
  };

  const swapCenterTopBottom = () => {
    setCenterOrder(([top, bottom]) => [bottom, top]);
  };

  return {
    positions,
    centerOrder,
    swapLeftCenter,
    swapRightCenter,
    swapCenterTopBottom,
  };
}
